import { TextField } from '@mui/material';
import React from 'react';
import { IMaskInput } from 'react-imask';

import FormFieldHelperAction, { IHelperAction } from './FormFieldHelperAction';

const PatternMaskInput = React.forwardRef<
  HTMLInputElement,
  {
    definitions?: Record<string, RegExp>;
    maskPattern: string;
    onValueChange: (value: string) => void;
    unmask?: boolean;
  }
>(function PatternMaskInput(
  { definitions, maskPattern, onValueChange, unmask, ...other },
  ref,
) {
  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      lazy
      definitions={definitions}
      mask={maskPattern}
      overwrite
      unmask={unmask}
      onAccept={(value) => onValueChange(String(value).toUpperCase())}
      placeholderChar=" "
    />
  );
});

const FormComponent: React.FC<{
  disabled?: boolean;
  error: any;
  helperAction?: IHelperAction;
  helperText?: string;
  definitions?: Record<string, RegExp>;
  label: string;
  maskPattern: string;
  name: string;
  onValueChange: any;
  placeholder: string;
  size?: 'small' | 'medium';
  readOnly?: boolean;
  required?: boolean;
  unmask?: boolean;
  value: any;
}> = (props) => {
  const {
    disabled = false,
    error,
    helperAction,
    helperText = '',
    definitions,
    label,
    maskPattern,
    name,
    onValueChange,
    placeholder,
    readOnly = false,
    required = false,
    unmask,
    value,
  } = props;

  return (
    <>
      <TextField
        disabled={disabled}
        error={error}
        fullWidth
        helperText={helperText}
        label={`${label}${required ? '*' : ''}`}
        placeholder={placeholder}
        name={name}
        value={value}
        slotProps={{
          input: {
            readOnly,
            inputComponent: PatternMaskInput as any,
            inputProps: {
              definitions,
              maskPattern,
              onValueChange,
              unmask,
              'data-testid': name,
            },
          },
        }}
        size={props.size || 'small'}
      />
      <FormFieldHelperAction action={helperAction} />
    </>
  );
};

export default FormComponent;
